import { arrayRemove } from 'firebase/firestore';
import { createRefPath, createRefPath_event } from '../appData/appRefPaths';

export const updateAppUserProfile = (database_fns, docId, dataToUpdate, callback) => {
  const _updateRef = createRefPath(['profiles', docId])
  database_fns.update_doc(_updateRef, dataToUpdate, callback)
}

/**
 * clears fcmTokesn from the topicCollection colllection in firebase
 * @param {*} dbTopics 
 * @param {*} fcmToken 
 * @param {*} pathViews 
 * @param {*} topicCollection 
 * @returns 
 */
export const removeFcmTokenFromTokens = async (dbTopics, fcmToken, pathViews, topicCollection) => {

  const promises = []

  // eslint-disable-next-line
  if (dbTopics) {
    Object.keys(dbTopics).map((topicKey) => {
      const _ref = createRefPath_event(pathViews, [topicCollection, topicKey])
      const _dataToUpdate = { fcmTokens: arrayRemove(fcmToken) }
      promises.push(database_fns.update_doc(_ref, _dataToUpdate, false, true))
    });
  }

  return Promise.all(promises)

};